import { CategoryPageQuery } from '../../graphql/CategoryPage.gql'

type CategoryItem = NonNullable<
  NonNullable<NonNullable<CategoryPageQuery['categories']>['items']>[number]
>

export type CategoryProductItemType = Pick<CategoryItem, 'uid' | 'name'> & {
  image?: string | null
  hashtag?: string
  onClick?: () => void
  isLinkItem?: boolean
}

export const createCategoryProductItem = ({
  uid,
  name,
  image = null,
  hashtag,
  onClick,
  isLinkItem,
}: {
  uid: string
  name: string
  image?: string | null
  hashtag: string
  onClick?: () => void
  isLinkItem?: boolean
}): CategoryProductItemType => ({
  uid,
  name,
  image,
  hashtag,
  onClick,
  isLinkItem,
})
